import React from 'react'
import './Experience.css'

const Experience = () => {
  const plakart = "../plakart.png"
  const tell = '../tell.png'
  return (
    <div className='experience_component'>
        <h2>Experiencia</h2>
        <div className="experience_card">
        <div className='job_as'>
            <img src={plakart} alt="Plakart SRL"/>
            <h4>Como desarrollador freelancer</h4>
        </div>
        <div>
            <p>
            Diseñé y desarrollé un sitio web completo para la empresa Plakart, especializada en diseño de interiores y mobiliario, utilizando HTML, CSS, SASS y Javascript.
            </p>
        </div>
        <div>
            <p>Puedes mirar el sitio web en: <a href="https://plakart.com.ar" target='blank' className='plakart_link'>plakart.com.ar</a></p>
        </div>
        </div>
    </div>
  )
}

export default Experience